import { render, staticRenderFns } from "./DynamicGemTypeCard.vue?vue&type=template&id=94867d70&scoped=true"
import script from "./DynamicGemTypeCard.vue?vue&type=script&lang=ts"
export * from "./DynamicGemTypeCard.vue?vue&type=script&lang=ts"
import style0 from "./DynamicGemTypeCard.vue?vue&type=style&index=0&id=94867d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94867d70",
  null
  
)

export default component.exports